import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=da1fa85c&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da1fa85c')) {
      api.createRecord('da1fa85c', component.options)
    } else {
      api.reload('da1fa85c', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=da1fa85c&", function () {
      api.rerender('da1fa85c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-229E3io7NnGl6/JS/comp/childrenage.vue"
export default component.exports